import React from 'react';
import { duplicationText } from '../../../constants/initiativeDuplication.js';
import styles from '../../projects/duplicate/DuplicateProjectModal.module.css';

const BLOCKS = ['alwaysCopied', 'feedbackForm', 'neverCopied'];

const WhatGetsCopiedTooltip = () => (
  <div>
    {BLOCKS.map((block) => (
      <div key={block} className={styles.tooltipBlock}>
        <strong>{duplicationText(`tooltip.${block}Title`)}</strong>
        <p className="text-muted">{duplicationText(`tooltip.${block}`)}</p>
      </div>
    ))}
  </div>
);

export default WhatGetsCopiedTooltip;
